import React, { useEffect, useState } from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { slugify } from "../../utils/slugify";
import CommonBreadcrumbs from "../../components/Breadcrumb/Breadcrumb";
import { images } from "../../config/images";
import Aos from "aos";
import { career } from "../../config/services";
import "./Career.css";
import FullpageLoader from "../../Fullscreen/FullScreenLoader";
import { CareerShimmer } from "../../components/Shimmer/Shimmer";

const CustomPagination = styled(Pagination)(({ theme }) => ({
  "& .MuiPaginationItem-root": {
    borderColor: "var(--accent-color)",
    borderWidth: "1px",
    borderStyle: "solid",
    marginTop: "30px",
  },
  "& .Mui-selected": {
    borderColor: "var(--accent-color)",
    backgroundColor: "var(--accent-color) !important",
    color: "var(--white)",
  },
}));

const Career = ({ settingAPIData, headerAPIData }) => {
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [careerAPIData, setCareerAPIData] = useState([]);
  const [careerLoading, setCareerLoading] = useState(false);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };
  useEffect(() => {
    handlecareer();
  }, [currentPage]);

  const handlecareer = async () => {
    setCareerLoading(true);
    try {
      const resp = await career(currentPage, perPage);
      if (resp.data.code === 200 || resp.data.code === 201) {
        setCareerAPIData(resp.data.responseBody);
        setCareerLoading(false);
      }
    } catch (error) {
      console.log("handlesubmit", error);
    }
  };

  const handleClick = (job) => {
    navigate(`/applynow/${slugify(job.title)}`, { state: { careerId: job.id } });
  };

  const breadcrumbsData = [
    { label: "Home", url: "/" },
    {
      label: "Career",
      url: "/career",
    },
  ];

  useEffect(() => {
    Aos.init({ duration: 2400 });
  }, []);

  return (careerAPIData && headerAPIData).length === 0 ? (
    <FullpageLoader />
  ) : (
    <>
      <div className="">
        <div className="about-us-container">
          <div className="molecule left">
            <img
              src={images.leftSpirrel}
              alt="Left Molecule"
              className="left-spinner"
            />
          </div>
          <div className="about-text">
            <h1>Career</h1>
            <CommonBreadcrumbs items={breadcrumbsData} separator="›" />
          </div>
          <div className="molecule right">
            <img
              src={images.rightSpirrel}
              alt="Right Molecule"
              className="right-spinner"
            />
          </div>
        </div>
        <div className="home pt-5 pb-5 contact-container">
          <div className="career-requirements-header">
            <h4 className="career-section-title text-center">Requirements</h4>
          </div>

          <div className="carrer-page common-sec">
            {careerLoading ? (
              <CareerShimmer />
            ) : careerAPIData.data && careerAPIData.data.length > 0 ? (
              careerAPIData.data.map((job, index) => (
                <div key={job.id} className={index > 0 ? "mt-3" : ""}>
                  <div className="career-requirements-wrap">
                    <div className="career-requirements">
                      <h4 className="career-position">
                        {job.title}
                        {job.description ? ` – ${job.description}` : ""}
                      </h4>
                      <h5 className="career-experience">
                        {job.expection} years of Exp
                      </h5>
                      <h6 className="career-background">{job.background}</h6>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="career-apply-now-btn"
                        onClick={() => handleClick(job)}
                      >
                        Apply Now!
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="career-empty-state" role="status" aria-live="polite">
                <div className="career-empty-state-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </div>
                <h3>No openings right now</h3>
                <p>There are no job requirements listed at the moment. Check back later or follow us for updates on new opportunities.</p>
              </div>
            )}
          </div>
          {careerAPIData.data && careerAPIData.data.length > 0 && careerAPIData.total > 0 && (
            <div className="career-pagination-wrap">
              <Stack spacing={2}>
                <CustomPagination
                  count={Math.ceil(
                    careerAPIData.total / (careerAPIData.per_page || perPage)
                  )}
                  page={currentPage}
                  onChange={handlePageChange}
                  siblingCount={1}
                  boundaryCount={2}
                />
              </Stack>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Career;
